// A device's fingerprint as people compare it: the waiting browser shows its own, the
// approving device shows the one the API lists, and they must match (docs/07 "Linked
// devices"). Both are computed locally from the auth public key by ocs-proto, so the API
// cannot make a stranger's key look like the user's.
import type { SigAlg } from "../proto/frames";
import type { Proto } from "../proto/index";

/** The first 80 bits of the key's SHA-256 fingerprint, in groups of four hex digits. */
export function deviceFingerprint(proto: Pick<Proto, "accountKeyFingerprint">, alg: SigAlg, publicKey: Uint8Array): string {
  const hex = proto.accountKeyFingerprint(alg, publicKey).slice(0, 20);
  return hex.match(/.{4}/g)?.join(" ") ?? hex;
}
